<template>
  <div class="modal-level2-pagination">
    <div class="mlp-wrapper">
      <div>Tampilan Baris</div>
      <div class="mlp-rows-setting">
        <b-form-select
          v-model="totalPerPage"
          :options="modes"
          class="row-setting-wrapper"
        ></b-form-select>
      </div>
      <div class="mlp-pagination-wrapper">
        <b-pagination
          aria-controls="isupplier-table"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="totalPerPage"
          align="fill"
          class="mlp-pagination"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modes: [1, 5, 10, 15, 25],
    }
  },
  computed: {
    totalItems() {
      return this.$store.state.level1.poTotalItems
    },
    totalPerPage: {
      get: function() {
        return this.$store.state.level1.poPerPage
      },
      set: function(newValue) {
        this.$store.dispatch('level1/setPoPerPage', newValue)
      },
    },
    currentPage: {
      get: function() {
        return this.$store.state.level1.poPage
      },
      set: function(newValue) {
        this.$store.dispatch('level1/setPoPage', newValue)
      }
    }
  }
}
</script>